import fetch from 'isomorphic-fetch';
import { config } from '../../../../core/config/config';
import store from '../../../../core/redux/store';

export const createDriver = async (
  name: string,
  email: string,
  mobile_no: string,
  vehicle_type: string,
  payment_setting: string,
  employee_code: string,
  password: string
): Promise<any> => {
  try {
    const state = store.getState();
    const token = state.token.token;
    const orgId = state.me.me.organization?.id;
    if (!orgId) {
      throw new Error('Missing organization ID: cannot create driver without an organization.');
    }
    const uri = `${config.uri.loop_pro_api}/api/fleet/${orgId}/fleet/create-driver`;
    const options = {
      method: 'POST',
      headers: new Headers({
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify({
        name,
        email,
        mobile_no,
        payment_setting,
        vehicle_type,
        employee_code,
        password
      })
    };

    const response = await fetch(uri, options);
    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || 'Something went wrong');
    }

    return result;
  } catch (err) {
    throw err;
  }
};
